import { render, staticRenderFns } from "./Slideshow.vue?vue&type=template&id=afb9e8dc"
import script from "./Slideshow.vue?vue&type=script&lang=js"
export * from "./Slideshow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports